<template>
  <transition mode="out-in" appear @enter="enter" @leave="leave" :css="false">
    <div class="wrapper">
      <FrameBook></FrameBook>
      <div class="signature-slick">
        <section class="signature">
          <div class="signature__bg">
            <div class="signature__bg-view">
              <video
                id="classLoopVideo0"
                src="https://vod.plaync.com/LineageW/TL_Town_B-10mB.mp4"
                muted
                playsinline
                loop
              />
            </div>
          </div>
          <div class="signature__contents">
            <div class="signature__txt">
              <div class="signature__txt-bg"></div>
              <div class="signature__txt-bl">
                <span class="bl--1"></span><span class="bl--2"></span
                ><span class="bl--3"></span>
                <hr class="bl--r" />
                <hr class="bl--l" />
              </div>
              <div
                class="signature__txt-tit"
                v-html="$t('signature.flicking-1.title')"
              ></div>
            </div>
            <div class="signature__story">
              <div class="signature__story-view" v-html="$t('signature.flicking-1.desc')"></div>
            </div>
            <button class="signature__btn" @click="showStory(1)" v-html="$t('signature.btn')"></button>
          </div>
        </section>
        <section class="signature">
          <div class="signature__bg">
            <div class="signature__bg-view">
              <video
                id="classLoopVideo1"
                src="https://vod.plaync.com/LineageW/GL_Town_B-10mB.mp4"
                muted
                playsinline
                loop
              />
            </div>
          </div>
          <div class="signature__contents">
            <div class="signature__txt">
              <div class="signature__txt-bg"></div>
              <div class="signature__txt-bl">
                <span class="bl--1"></span><span class="bl--2"></span
                ><span class="bl--3"></span>
                <hr class="bl--r" />
                <hr class="bl--l" />
              </div>
              <div
                class="signature__txt-tit"
                v-html="$t('signature.flicking-2.title')"
              ></div>
            </div>
          </div>
          <div class="signature__story">
            <div class="signature__story-view" v-html="$t('signature.flicking-2.desc')"></div>
          </div>
          <button class="signature__btn" @click="showStory(2)" v-html="$t('signature.btn')"></button>
        </section>
        <section class="signature">
          <div class="signature__bg">
            <div class="signature__bg-view">
              <video
                  id="classLoopVideo2"
                  src="https://vod.plaync.com/LineageW/FO_Town_B-10mB.mp4"
                  muted
                  playsinline
                  loop
                />
            </div>
          </div>
          <div class="signature__contents">
            <div class="signature__txt">
              <div class="signature__txt-bg"></div>
              <div class="signature__txt-bl">
                <span class="bl--1"></span><span class="bl--2"></span
                ><span class="bl--3"></span>
                <hr class="bl--r" />
                <hr class="bl--l" />
              </div>
              <div
                class="signature__txt-tit"
                v-html="$t('signature.flicking-3.title')"
              ></div>
            </div>
            <div class="signature__story">
              <div class="signature__story-view" v-html="$t('signature.flicking-3.desc')"></div>
            </div>
            <button class="signature__btn" @click="showStory(3)" v-html="$t('signature.btn')"></button>
          </div>
        </section>
        <section class="signature">
          <div class="signature__bg">
            <div class="signature__bg-view">
                <video
                  id="classLoopVideo3"
                  src="https://vod.plaync.com/LineageW/WIN_Town_B-10mB.mp4"
                  muted
                  playsinline
                  loop
                />
            </div>
          </div>
          <div class="signature__contents">
            <div class="signature__txt">
              <div class="signature__txt-bg"></div>
              <div class="signature__txt-bl">
                <span class="bl--1"></span><span class="bl--2"></span
                ><span class="bl--3"></span>
                <hr class="bl--r" />
                <hr class="bl--l" />
              </div>
              <div
                class="signature__txt-tit"
                v-html="$t('signature.flicking-4.title')"
              ></div>
            </div>
            <div class="signature__story">
              <div class="signature__story-view" v-html="$t('signature.flicking-4.desc')"></div>
            </div>
            <button class="signature__btn" @click="showStory(4)" v-html="$t('signature.btn')"></button>
          </div>
        </section>
      </div>
      <ScrollBtn></ScrollBtn>
    </div>
  </transition>
</template>

<script>
import BaseSection from "./mixins/BaseSection.js";
import gsap from "gsap";
import FrameBook from "@/components/FrameBook";
import ScrollBtn from "../components/ScrollBtn";
import promokit from "@/utils/promokit";

export default {
  name: "signature",
  components: { FrameBook, ScrollBtn},
  mixins: [BaseSection],
  data() {
    return {
      name: "signature",
      bg: null,
      titMotion: null,
      indexLoopVideo: null,
      indexLoopVideo1: null,
      indexLeaveVideo: null,
      slickOptions: {
        arrows: true,
        dots: true,
        infinite: true,
        speed: 300,
        slidesToShow: 1,
        initialSlide: 3,
        autoplay: false,
        autoplaySpeed: 4000,
        fade: true,
        pauseOnHover: true,
      },
      storyLayerData: {
        1: {
          clipId: "1",
          desc: `${this.$t("signature.flicking-1.desc")}`,
        },
        2: {
          clipId: "2",
          desc: `${this.$t("signature.flicking-2.desc")}`,
        },
        3: {
          clipId: "3",
          desc: `${this.$t("signature.flicking-3.desc")}`,
        },
        4: {
          clipId: "3",
          desc: `${this.$t("signature.flicking-4.desc")}`,
        },
      },
    };
  },
  methods: {
    setMotion() {
      this.enterMotion = new gsap.timeline({
        paused: true,
        onStart: () => {
          this.setIsMovePage(true);
        },
      });
      this.enterMotion
        .addLabel("start")
        .from(this.$el, 0.5, { opacity: 0, ease: "power2.easeOut" });
    },
    leave(el, done) {
      gsap.to(this.$el, 0.5, { opacity: 0, onComplete: done });
      $(".signature-slick").slick("unslick");
    },
    enter(el, done) {
      this.setMotion();
      this.enterMotion.eventCallback("onComplete", () => {
        done();
        this.setIsMovePage(false);
      });
      if (this.currentPage == "index") this.autoPlay = false;
      this.setCurrentPage(this.name);
      this.setEnterPage(this);
    },
    start() {
      this.enterMotion.play();
      //this.titMotion.play();
    },
    showStory(turn) {
      let player = [];
      let slickOption = {
        arrows: true,
        dots: true,
        infinite: false,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        initialSlide: turn,
      };
      const youtubeLayerDataLangth = 2;
      let titList = [];

      const parseRange = document.createRange();
      const parse = Range.prototype.createContextualFragment.bind(parseRange);
      let layerEle = `
            <div id="storyLayer" class="signature__mstory">
              <div class="signature__mstory-deps${turn}">
                <div class="signature__mstory-view">
                ${this.storyLayerData[turn].desc}
                </div>
              </div>
      `;
      layerEle += `</div>`;
      document.querySelector("body").appendChild(parse(layerEle));

      const layer = promokit.layer({
        el: "#storyLayer",
        render: true,
        //autoplayVideo: player[turn],
      });
      
      layer.open();
      layer.on("closeend", () => {
        document.querySelector(".promokit-layer").remove();
      });
    },
  },
  mounted() {
    $(".signature-slick")
      .slick(this.slickOptions)
      .on("beforeChange", function (event, slick, currentSlide) {
        $(
          ".signature__txt-bl .bl--1, .signature__txt-bl .bl--2, .signature__txt-bl .bl--3, .signature__txt-bl .bl--r, .signature__txt-bl .bl--l, .signature__txt-bg, .signature__txt-tit, .signature__story, .scroll-btn"
        ).css("opacity", 0);
        let turn = currentSlide;
        this.indexLoopVideo = document.querySelector(`#classLoopVideo${turn}`);
        this.indexLoopVideo.pause();
      })
      .on("afterChange", function (event, slick, currentSlide) {
        let turn = currentSlide;
        this.indexLoopVideo = document.querySelector(`#classLoopVideo${turn}`);
        this.indexLoopVideo.play();
        
        const t1 = gsap.timeline();
        t1.addLabel("title")
          .fromTo(
            ".signature__txt-bl .bl--1",
            0.4,
            { autoAlpha: 0, rotation: 190 },
            { autoAlpha: 1, rotation: 0, ease: "expo.easeInOut" },
            "title"
          )
          .fromTo(
            ".signature__txt-bl .bl--2",
            0.4,
            { autoAlpha: 0, rotation: -190 },
            { autoAlpha: 1, rotation: 0, ease: "expo.easeInOut" },
            "title"
          )
          .fromTo(
            ".signature__txt-bl .bl--3",
            0.4,
            { autoAlpha: 0, scale: 3 },
            { autoAlpha: 1, scale: 1, ease: "Back.easeOut" },
            "title"
          )
          .fromTo(
            ".signature__txt-bl .bl--r",
            0.4,
            { autoAlpha: 0, x: -30, y: -5 },
            { autoAlpha: 1, x: 0, y: 0, ease: "expo.easeInOut" },
            "title+=0.2"
          )
          .fromTo(
            ".signature__txt-bl .bl--l",
            0.4,
            { autoAlpha: 0, x: 30, y: -5 },
            { autoAlpha: 1, x: 0, y: 0, ease: "expo.easeInOut" },
            "title+=0.2"
          )
          .fromTo(
            ".signature__txt-bg",
            0.4,
            { autoAlpha: 0, y: -10 },
            { autoAlpha: 1, y: 0, ease: "expo.easeOut" },
            "title+=0.2"
          )
          .fromTo(
            ".signature__txt-tit",
            0.4,
            { autoAlpha: 0, y: 30 },
            { autoAlpha: 1, y: 0, ease: "expo.easeOut" },
            "title+=0.4"
          )
          .fromTo(
            ".signature__story",
            0.5,
            { autoAlpha: 0, y: -30 },
            { autoAlpha: 1, y: 0, ease: "expo.easeOut" },
            "title+=0.6"
          )
          .fromTo(
            ".scroll-btn",
            0.5,
            { autoAlpha: 0, y: 30 },
            { autoAlpha: 1, y: 0, ease: "expo.easeOut" },
            "title+=1.0"
          );
      });

    $(".signature-slick").slick("slickGoTo", 0);
    if (this.autoPlay) {
      this.start();
      this.setIsIntro(false);
    }
  },
};
</script>

<style lang="scss">

.show_pc{
  display: inline-block;
}
.show_mobile{
  display: none;
}
@include bp(tablet){
  .show_pc{
    display: none;
  }
  .show_mobile{
    display: inline-block;
  }
}
@mixin settitle($nation) {
  $columns: 3;
  @for $i from 0 through $columns {
    div[data-slick-index="#{$i}"] {
      .signature {
        &__txt {
          &-tit {
            @include bg(
              $bg: "../assets/img/#{$nation}/signature_tit#{$i+1}_#{$nation}.png",
              $cover: cover
            );
            @include bp(tablet) {
              @include bg(
                $bg:
                  "../assets/img/#{$nation}/signature_tit#{$i+1}_#{$nation}_m.png"
              );
            }
          }
        }
      }
    }
  }
}


:lang(en) {
  div[data-slick-index="0"] {
    .signature {
      &__txt {
        &-tit {
           @include bp(tablet) {
            width: 300px;
            margin-left: -150px;
          }
        }
      }
      &__story {
        &-view {
          margin-top: 105px;
        }
      }
    }
  }
  div[data-slick-index="1"] {
    .signature {
      &__txt {
        &-tit {
           @include bp(tablet) {
            width: 200px;
            margin-left: -100px;
            top: 70px;
          }
        }
      }
    }
  }
  div[data-slick-index="3"] {
    .signature {
      &__story {
        &-view {
          margin-top: 105px;
        }
      }
    }
  }
  .signature {
    &__txt {
      &-tit {
        width: 1347px;
        height: 329px;
        margin-left: -673px;
        background-size: auto !important;
      }
    }
    &__story {
      &-view {
        letter-spacing: -1px;
      }
    }
    &__mstory {
      &-view {
        @include bp(tablet){
          letter-spacing: -0.6px;
        }
      }
      &-deps4{
        @include bp(tablet){
         margin-top: -170px;
        }
      }
    }
  }
  @include settitle($nation: en);
  @include bp(tablet) {
    .slick-slide {
      .signature {
        &__txt {
          &-tit {
            width: 257px;
            height: 93px;
            margin-left: -128px;
          }
        }
      }
    }
  }
}

:lang(ja) {
  @include settitle($nation: ja);
  @include bp(tablet) {
    .slick-slide {
      .signature {
        &__txt {
          &-tit {
            width: 258px;
            height: 90px;
            margin-left: -129px;
          }
        }
      }
    }
  }
  .signature {
    &__txt {
      &-tit {
        width: 1248px;
        height: 140px;
        margin-left: -624px;
        background-size: auto !important;
        @include bp(tablet) {
          background-size: cover !important;
        }
      }
    }
    &__mstory {
      &-view {
        @include bp(tablet){
          letter-spacing: -1px;
        }
      }
      &-deps3{
        @include bp(tablet){
         margin-top: 30px;
        }
      }
    }
  }
}

:lang(zh) {
  @include settitle($nation: zh);
  @include bp(tablet) {
    .slick-slide {
      .signature {
        &__txt {
          &-tit {
            width: 178px;
            height: 92px;
            margin-left: -89px;
          }
        }
      }
    }
  }
  .signature {
    &__txt {
      &-tit {
        width: 981px;
        height: 153px;
        margin-left: -490px;
        background-size: auto !important;
        @include bp(tablet) {
          background-size: cover !important;
        }
      }
    }
    &__mstory {
      &-deps3{
        @include bp(tablet){
          margin-top: 20px;
        }
      }
    }
  }
}

.wrapper {
  width: 100%;
  height: 100%;
}

@media (min-width: 1261px) {
  .signature-slick {
    .slick-dots {
      @include bg($bg: "../assets/img/icon_slick_dot-paradigm-bg.png");
      @include position(
        $position: absolute,
        $left: 50%,
        $bottom: 0,
        $width: 998px,
        $height: 350px
      );
      background-size: 100%;
      li {
        margin: 0;
        button {
          width: 160px;
          height: 102px;
          @include bg($bg: "../assets/img/icon_slick_dot-signature.png");
          background-position: -15px -24px;
          margin-top: 150px;
        }
        &:nth-of-type(2) {
          button {
            background-position-x: -175px;
          }
        }
        &:nth-of-type(3) {
          margin-left: 2px;
          button {
            background-position-x: -337px;
          }
        }
        &:nth-of-type(4) {
          button {
            background-position-x: -497px;
          }
        }
        &.slick-active {
          button {
            background-position-y: -143px;
          }
        }
      }
    }
    .slick-arrow {
      @include position(
        $position: absolute,
        $left: 50%,
        $bottom: 119px,
        $width: 39px,
        $height: 42px
      );
      @include bg($bg: "../assets/img/icon_slick_arrow-paradigm.png");
      top: auto;

      &.slick-prev {
        margin-left: -370px;
      }
      &.slick-next {
        margin-left: 329px;
      }
    }
  }
}

.signature-slick {
  height: 100%;
  .slick-list {
    height: 100%;
    .slick-track {
      height: 100%;
      .slick-slide {
        & > div {
          height: 100%;
        }
      }
    }
  }
  .slick-arrow {
    @include bp(tablet) {
      width: 59px !important;
      height: 56px !important;
      &.slick-prev {
        left: 5px !important;
      }
      &.slick-next {
        right: 5px !important;
      }
    }
  }
}

$columns: 3;
@for $i from 0 through $columns {
  div[data-slick-index="#{$i}"] {
    .signature {
      &__txt {
        &-tit {
          @include bg($bg: "../assets/img/ko/signature_tit#{$i+1}.png");
        }
      }
    }
  }
}
@include bp(tablet) {
  .slick-slide {
    .signature {
      &__txt {
        &-bl {
          display: none;
        }
        &-bg {
          display: none;
        }
        &-tit {
          width: 174px;
          height: 93px;
          margin-left: -87px;
          top: 80px;
          background-size: contain !important;
        }
      }
    }
  }
  
  div[data-slick-index="0"] {
    .signature {
      &__txt {
        &-tit {
          @include bg($bg: "../assets/img/ko/signature_tit1_m.png");
        }
      }
    }
  }
  div[data-slick-index="1"] {
    .signature {
      &__txt {
        &-tit {
          @include bg($bg: "../assets/img/ko/signature_tit2_m.png");
        }
      }
    }
  }
  div[data-slick-index="2"] {
    .signature {
      &__txt {
        &-tit {
          @include bg($bg: "../assets/img/ko/signature_tit3_m.png");
        }
      }
    }
  }
  div[data-slick-index="3"] {
    .signature {
      &__txt {
        &-tit {
          @include bg($bg: "../assets/img/ko/signature_tit4_m.png");
        }
      }
    }
  }
}

.signature {
  height: 100%;
  position: relative;
  &__bg {
    @include position($width: 100%, $height: 100%);
    overflow: hidden;
    &-view {
      @include position(
        $position: absolute,
        $top: 0,
        $left: 0,
        $width: 100%,
        $height: 100%
      );
      &::after {
        display: block;
        content: "";
        width: 100%;
        height: 100%;
        background-color: rgba($color: black, $alpha: 0.1);
        position: absolute;
        left: 0;
        top: 0;
      }
      video {
        min-width: 100% !important;
        min-height: 100% !important;
        width: auto;
        height: auto;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        &#indexLeaveVideo {
          display: none;
        }
      }
    }
  }
  &.__contents {
    @include position($position: absolute, $top: 50%, $left: 50%);
    transform: translateX(-50%) translateY(-50%);
    width: 100%;
    height: 100%;
  }
  &__txt {
    @include position(
      $position: absolute,
      $width: 100%,
      $height: 563px,
      $top: 24px,
      $left: 50%
    );
    &-bg {
      @include position(
        $position: absolute,
        $width: 100%,
        $height: 100%,
        $top: 0,
        $left: 50%
      );
      @include bg($bg: "../assets/img/tit_bg.png", $position: 50% 0);
      transform-origin: 50% 180px;
      transform: scale(0.8);
    }
    margin-top: -70px;
    &-bl {
      @include position(
        $position: absolute,
        $width: 100%,
        $height: 34px,
        $top: 157px,
        $left: 50%
      );
      > span {
        display: block;
        @include position(
          $position: absolute,
          $width: 34px,
          $height: 34px,
          $top: 0,
          $left: 50%
        );
        @include bg($bg: "../assets/img/tit_icon_b.png");
        &:nth-child(1) {
          background-position-x: 0;
        }
        &:nth-child(2) {
          background-position-x: -34px;
        }
        &:nth-child(3) {
          background-position-x: -68px;
        }
      }
      > hr {
        border: none;
        @include position(
          $position: absolute,
          $width: 96px,
          $height: 14px,
          $top: 2px,
          $left: 50%
        );
        @include bg($bg: "../assets/img/tit_icon_l.png");
        margin-left: 17px;
        &:last-child {
          @include bg($bg: "../assets/img/tit_icon_r.png");
          margin-left: -113px;
        }
      }
    }
    &-tit {
      @include position(
        $position: absolute,
        $width: 939px,
        $height: 126px,
        $top: 220px,
        $left: 50%
      );
      @include hide-text;
      @include bp(tablet) {
        background-size: cover !important;
      }
    }
  }
  
  &__story {
    @include position(
      $position: absolute,
      $width: 1667px,
      $height: 593px,
      $top: 260px,
      $left: 50%
    );
    @include bg($bg: "../assets/img/signature_desc_bg.png");
    margin-left: -833px;
    
    @include bp(tablet) {
      display: none;
    }
    &-view {
      text-align: center;
      font-family: "LineageWIdentity";
      font-size: 24px;
      color: rgba($color: #fffbe4, $alpha: 0.7);
      text-shadow: 1px 1px 5px #000;
      margin-top: 155px;
      line-height: 60px;
    }
  }
  &__mstory {
    display: none;
    @include bp(tablet) {
      display: block;
      @include position(
        $position: absolute,
        $width: (
          100%,
        ),
        $height: (
          100%,
        ),
        $top: 0,
        $left: 0
      );
      background: rgba($color: #000, $alpha: 0.9);
      z-index: 1000;
    }
    &-view {
      @include bp(tablet){
        text-align: center;
        font-family: "LineageWIdentity";
        font-size: 13px;
        color: rgba($color: #fffbe4, $alpha: 0.7);
        text-shadow: 1px 1px 5px #000;
        margin-top: -140px;
        line-height: 30px;
      }
    }
    &-deps4{
      @include bp(tablet){
        margin-top: -160px;
      }
    }
  }
  &__btn {
  display: none;
  @include bp(tablet) {
      display: block;
      @include bg($bg: "../assets/img/signature_btn_m.png");
      background-size: 100% auto;
      @include position(
        $position: absolute,
        $width: (
          107px,
        ),
        $height: (
          86px,
        ),
        $top: 50%,
        $left: 50%
      );
      margin-left: -48.5px;
      margin-top: 39%;
      @include hide-text;
    }
  }

}


div[data-slick-index="1"] {
  .signature {
    &__txt {
      z-index: 10;
    }
  }
}

.signature-slick + .scroll-btn {
  @include bp(tablet) {
    width: 56px;
    height: 42px;
    margin-left: -28px;
    .scroll-btn__con {
      background-image: url("../assets/img/icon_down_m1.png");

      &::after {
        display: none;
      }
    }
  }
}

//영상관련
.signature{
  @include bp(tablet) {
    &__bg {
      min-height: auto;
      &-view {
        video {
          height: 100%;
        }
      }
    }
  }
  @media (max-width: 960px) and (min-aspect-ratio: 1920/1080) {
    &__bg {
      &-view {
        video {
          width: 100%;
          height: auto;
        }
      }
    }
  }
}


  
</style>